import ApiService from '../common/api.service'

class SDFilterService extends ApiService {

  /**
   * POST status.
   * @param status New status
   * @returns {*|any|Promise.<TResult>}
   */
  changeUserSDFilterStatus (status) {
    this.$log.debug('Edit User Global SD Filter preference')
    const token = this.getCurrentToken()
    if (token) {
      return this.post(`/sdfilter/user/status`, null, {
        params: {
          'token': token.access_token,
          'status': status
        }
      }).then((res) => {
        this.$log.info(' completed', res.data)
        return Promise.resolve(res.data)
      }, (err) => {
        return Promise.reject(err)
      })
    }
  }

  /**
   * POST mountId and status.
   * @param mountId Name of the SD card
   * @param status New status
   * @returns {*|any|Promise.<TResult>}
   */
  changeSDDeviceFilterStatus (mountId, status) {
    this.$log.debug('Edit User SD Filter preferences')
    const token = this.getCurrentToken()
    if (token) {
      return this.post(`/sdfilter/device/status`, null, {
        params: {
          'token': token.access_token,
          'mountId': mountId,
          'status': status
        }
      }).then((res) => {
        this.$log.info('completed', res.data)
        return Promise.resolve(res.data)
      }, (err) => {
        return Promise.reject(err)
      })
    }
  }

  /**
   * GET SD filter for current user
   * @returns {*}
   */
  getUserSDFilter () {
    this.$log.debug('Get User SD Filter preferences')
    const token = this.getCurrentToken()
    return this.get(`/sdfilter/user`, {
      params: {
        'token': token.access_token
      }
    })
      .then((res) => {
        return Promise.resolve(res.data)
      })
  }

  /**
   * Get current token from the session storage
   * @return {Object} token
   */
  getCurrentToken () {
    const { token } = this.$window.sessionStorage
    return token ? JSON.parse(token) : null
  }
}

export default SDFilterService



// WEBPACK FOOTER //
// ./src/app/services/sdfilter/sdfilter.service.js